import type { JSX } from 'react';
import { monoLabel } from '../shell/look';
import { OtpBoxes } from './otp-boxes';
import { resendLabel } from './sign-in';
import type { SignIn } from './use-sign-in';

export function CodeStep({ signIn }: { signIn: SignIn }): JSX.Element {
  const waiting = signIn.resendIn > 0;
  return (
    <div className="flex flex-col gap-2.5">
      <span className={monoLabel}>6-DIGIT CODE</span>
      <OtpBoxes state={signIn.otp} onAction={signIn.onOtp} />
      <div className="text-mute flex items-center justify-between gap-3 text-[12.5px]">
        <span className="min-w-0 truncate">Sent to {signIn.email.trim()}</span>
        <button
          type="button"
          onClick={signIn.resend}
          disabled={waiting}
          className="flex-none border-0 bg-transparent p-0 text-[12.5px]"
          style={{
            color: waiting ? 'var(--mute)' : 'var(--acc)',
            cursor: waiting ? 'default' : 'pointer',
          }}
        >
          {resendLabel(signIn.resendIn)}
        </button>
      </div>
    </div>
  );
}
